import { createSlice } from '@reduxjs/toolkit';
// ----------------------------------------------------------------------

function objFromArray(array, key = 'id') {
    return array.reduce((accumulator, current) => {
        accumulator[current[key]] = current;
        return accumulator;
    }, {});
}

const initialState = {
    isLoading: false,
    roleSelected: {},
    contactSelected: {},
    ticketSelected: {}
};
//
const slice = createSlice({
    name: 'selected',
    initialState,
    reducers: {
        // START LOADING
        startLoading(state) {
            state.isLoading = true;
        },
        // HAS ERROR
        hasError(state, action) {
            state.isLoading = false;
            state.error = action.payload;
        },
        statusSetRoleSelectedSuccess(state, action) {
            const participants = action.payload;
            state.roleSelected = participants;
        },
        statusSetTicketSelectedSuccess(state, action) {
            const participants = action.payload;
            state.ticketSelected = participants;
        },
        statusSetContactSelectedSuccess(state, action) {
            const participants = action.payload;
            state.contactSelected = participants;
        },

    }
});

// Reducer
export default slice.reducer;


export function setContactSelected(param) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            dispatch(slice.actions.statusSetContactSelectedSuccess(param));
        } catch (error) {
            console.log(error)
            dispatch(slice.actions.hasError(error));
        }
    };
}
export function setTicketSelected(param) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            dispatch(slice.actions.statusSetTicketSelectedSuccess(param));
        } catch (error) {
            console.log(error)
            dispatch(slice.actions.hasError(error));
        }
    };
}

export function setRoleSelected(param) {
    return async (dispatch) => {
        dispatch(slice.actions.startLoading());
        try {
            dispatch(slice.actions.statusSetRoleSelectedSuccess(param));
        } catch (error) {
            console.log(error)
            dispatch(slice.actions.hasError(error));
        }
    };
}
